<template>
  <div id="wizardCard" class="card card-wizard">
    <div class="vue-form-wizard md">
      <div class="content">
        <div class="container">
          <div class="row">
            <legend>Servidores Inactivos</legend>
          </div>
            <div class="row">
              <div class="col-sm-6 col-md-6 col-lg-6">
              </div>
              <div class="col-sm-6 col-md-6 col-lg-6 pull-right">
                <b-form-group label-cols-sm="3" class="mb-0">
                  <b-input-group>
                    <b-form-input type="search" v-model="filter" placeholder="Buscar"></b-form-input>
                  </b-input-group>
                </b-form-group>
              </div>
            </div>
            <div class="row mt-3 mb-4">
              <div class="col-sm-12 col-md-12 col-lg-12">
                <v-data-table :headers="headers" :items="list_usuarios" :search="filter" :items-per-page="5" class="" :fixed-header="true" :custom-filter="buscaPers">
                  <template v-slot:item.acciones="{ item }" v-if="rol==4 || rol == 1">
                    <div class="d-flex justify-content-center">
                      <b-button @click.prevent="reactivar(item)" class="btn-s edit mr-2" variant="primary">
                        <i class="fas fa-unlock-alt"></i></b-button>
                    </div>
                  </template>
                  <template v-slot:item.rfc="{ item }">
                    <div>{{item.usuarios.rfc}} </div>
                  </template>
                  <template v-slot:item.nombres="{ item }">
                    <div>{{item.usuarios.nombres + ' '+ item.usuarios.primer_apellido +' '+item.usuarios.segundo_apellido}} </div>
                  </template>
                  <template v-slot:item.area="{ item }">
                    <div>{{item.encargo.area_adscripcion}}</div>
                  </template>
                  <template v-slot:item.inicia="{ item }">
                    <div>{{item.inicia | dateFormat }}</div>
                  </template>
                  <template v-slot:item.nombreUsuario="{ item }">
                    <div>{{item.usuario.Nombre + ' '+ item.usuario.Paterno +' '+item.usuario.Materno}} </div>
                  </template>
                </v-data-table>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import Vue from 'vue'
import moment from 'moment'
  import {
    Select,
    Option,
    DatePicker
  } from 'element-ui'

import {
    mapFields
  } from 'vee-validate'

import Domicilio from '../Domicilio.vue'

Vue.use(Select)
Vue.use(Option)
export default {
    components: {
      [DatePicker.name]: DatePicker
    },
    props: ['data'],
    data () {
      return {
        options: [{
          id: 1,
          label: 'foo'
        },
        {
          id: 3,
          label: 'bar'
        },
        {
          id: 2,
          label: 'baz'
        }
        ],
        filter: null,

        currentPage: 1,
        perPage: 50,
        rol: '',
        rows: null,
        id: 1,
        add_item: false,
        edit_item: null,
        tipos: null,
        n_domicilio: null,
        // dependencias: null,
        item_usuarios: {},
        list_usuarios: [],
        item_usuariosValidations: {
          rfc: {
            required: true
          },
          nombres: {
            required: true
          },
          primer_apellido: {
            required: true
          },
          segundo_apellido: {
            required: true
          },
          ente_publico_id: {
            required: true
          },
          direccion_cargo: {
            required: true
          },
          nivel: {
            required: true
          },
          area_adscripcion: {
            required: true
          },
          honorarios: {
            required: true
          },
          AG172: {
            required: true
          },
          fecha_inicio: {
            required: true
          },
          tipo_baja: {
            required: true
          },
          termina: {
            required: true
          },
          inicia: {
            required: true
          },
          tipo_lic: {
            required: true
          },
          observaciones: {
            required: true
          },
          empleo_cargo_comision: {
            required: true
          }
        },
        search: '',
        headers: [{
          text: 'Acciones',
          align: 'center',
          sortable: false,
          value: 'acciones',
          class: ''
        }, {
          text: 'RFC',
          value: 'rfc',
          align: 'center'
        }, {
          text: 'Nombre',
          value: 'nombres',
          align: 'center'
        },
        {
          text: 'Usuario que realizo la desactivación',
          value: 'nombreUsuario',
          align: 'center'
        },
        {
          text: 'Fecha de desactivación',
          value: 'inicia',
          align: 'center'
        },
        {
          text: 'Motivo',
          value: 'motivo',
          align: 'center'
        }
        ],
        selects: {
          simple: '',
          movimientos: [{
            value: '1',
            label: 'Desactivar servidor'
          },
          {
            value: '2',
            label: 'Crear baja '
          },
          {
            value: '3',
            label: 'Crear licencia'
          },
          {
            value: '4',
            label: 'Crear promoción'
          },
          {
            value: '5',
            label: 'Realizar corrección'
          },
          {
            value: '6',
            label: 'Cambiar contraseña'
          }
          ]
        }
      }
  },
    computed: {
      ...mapFields([
        'rfc',
        'nombres',
        'primer_apellido',
        'segundo_apellido',
        'ente_publico_id',
        'direccion_cargo',
        'nivel',
        'area_adscripcion',
        'honorarios',
        'AG172',
        'Password',
        'Confirmar',
        'fecha_inicio',
        'tipo_baja',
        'termina',
        'inicia',
        'tipo_lic',
        'observaciones',
        'empleo_cargo_comision'
      ]),
      to () {
        let highBound = this.from + this.perPage
        if (this.total < highBound) {
          highBound = this.total
        }
        return highBound
      },
      from () {
        return this.perPage * (this.currentPage - 1)
      },
      total () {
        this.rows = this.list_usuarios.length

        return this.list_usuarios.length
      },
      fullName: {
        get () {
          return `${this.item_usuarios.nombres} ${
          this.item_usuarios.primer_apellido
        } ${this.item_usuarios.segundo_apellido}`
        },
        set (newValue) {
          const m = newValue.match(/(\S*)\s+(.*)/)

          this.nombres = m[1]
          this.primer_apellido = m[2]
          this.segundo_apellido = m[3]
        }
      }
    },
    methods: {
      initItem () {
        this.item_usuarios = {
          acciones: '',
          nombres: '',
          Paterno: '',
          Materno: '',
          User: '',
          Password: ''
        }
      },
      showItem () {
        this.add_item = !this.add_item
      },
      cancelEdit () {
        if (this.edit_item) {
          this.edit_item.item._rowVariant = ''
        }
        this.initItem()
        this.showItem()
        this.edit_item = null
      },
      addItem () {
        this.$validator.validateAll().then(response => {
          if (response) {
            if (this.item_usuarios) {
              this.loadButton(this.$refs.btnSave)
              this.$http.post('usuarios', this.item_usuarios).then(
                response => {
                  this.StepOk('Guardado')
                  if (this.edit_item === undefined || this.edit_item === null) {
                    this.list_usuarios.push({
                      ...response.data.usuario
                    })
                  } else {
                    this.list_usuarios.splice(
                      this.edit_item.index,
                      1,
                      this.item_usuarios
                    )
                    this.edit_item.item._rowVariant = ''
                  }
                  this.initItem()
                  this.showItem()
                  this.edit_item = null
                },
                error => {
                  this.StepError(error)
                }
              )
            }
          } else {
            this.StepW('Hay campos sin completar')
          }
        })
      },
      editItem (indice) {
        this.showItem()
        this.edit_item = indice
        this.item_usuarios = {
          ...this.list_usuarios[this.edit_item.index]
        }
        this.edit_item.item._rowVariant = 'danger'
        $('.main-panel').animate({
          scrollTop: 100
        },
          500,
          'swing'
        )
      },
      reactivar (item) {
        this.Ask('¿Desea reactivar este usuario?', () => {
          this.$http.post('usuario/reactivar', item).then(
            response => {
              this.StepOk('Usuario activado correctamente')
            },
            error => {
              this.Err(error)
            }
          )
        })
      },
      removeItem (indice) {
        if (this.list_usuarios[indice].id !== null) {
          let item = this.list_usuarios[indice]
          this.list_usuarios.splice(indice, 1)
          this.Ask('Desea borrar este registro', () => {
            this.$http.delete('usuarios/' + item.id).then(
              response => {
                this.list_usuarios.splice(indice, 1)
              },
              error => {
                this.Err(error)
              }
            )
          })
        }
      },
      getError (fieldName) {
        return this.errors.first(fieldName)
      },
      getDependencias (index) {
        var resp = ' '
        if (this.dependencias) {
          this.dependencias.forEach(function (item) {
            if (item.id == index) {
              resp = item.valor
              return resp
            }
          })
        }
        return resp
      },
      buscaPers (value, search, item) {
        if (typeof value === 'string') {
          let nombre = ((item.usuarios.nombres || '') + ' ' + (item.usuarios.primer_apellido || '') + ' ' + (item.usuarios.segundo_apellido || '')).toLowerCase()
          let user = (item.usuarios.rfc || '').toLowerCase()
          return nombre.indexOf(search) !== -1 || user.indexOf(search) !== -1
        }
        return false
      }
    },
    created () {
      this.initItem()
      this.rol = this.getKey('role')
      if (this.rol == 4) {
        this.filtro = this.getKey('ente_publico_id')
      }

      this.$http.get('servidoresinactivos').then(
        response => {
          this.list_usuarios = response.data.usuarios
        // console.log(this.list_usuarios);
        },
        error => {
          this.Err(error)
        }
      )
    // this.$http.get("cat_ente_publico").then(
    //   response => {
    //     this.dependencias = response.data.entes_publicos;
    //   },
    //   error => {
    //     this.Err(error);
    //   }
    // );
  },
  mounted () {
    this.checkCatalogs()
  }
  }

</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Forms/Formularios/Movimientos/Inactivos.vue